import { stripSimpleMarkdown } from './simpleMarkdown';

export function buildVocabularyExampleSearchUrl(english) {
  const expression = stripSimpleMarkdown(english).replace(/\s+/g, ' ').trim();
  if (!expression) return '';

  const url = new URL('https://www.google.com/search');
  url.searchParams.set('q', `${expression} 예문`);
  return url.toString();
}
